import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0723653d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723653d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0723653d')) {
      api.createRecord('0723653d', component.options)
    } else {
      api.reload('0723653d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0723653d&scoped=true", function () {
      api.rerender('0723653d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/my_rotate/index.vue"
export default component.exports